export default function normalizeNumber(value: string): number | null {
    let res = null

    if (value) {
        // ignore , to acept 2,000 as 2000
        res = value.toString().replace(",","")

        res = parseInt(res)
        if (isNaN(res)) res = null
    }
    return res
}
